// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {Loading ,MessageBox ,Message} from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css';
import IScrollView from 'vue-iscroll-view'
import IScroll from 'iscroll'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import Utils from './utils'
import axios from "axios"
import Vueaxios from "vue-axios"
import dateTime from 'vue-date-time-m';
import Print from 'vue-print-nb'
/* eslint-disable no-new */
// 引入echarts


Vue.use(Print)
Vue.use(dateTime)
Vue.use(ElementUI)
Vue.use(VueVideoPlayer)
Vue.use(IScrollView, IScroll)
Vue.use(VueAwesomeSwiper)
Vue.use(Vueaxios , axios )
let loadingInstance='';

axios.interceptors.request.use(function (config) {
    if (config.url != '/api/index/Article' && config.url != '/api/SignUp/OrderQuery'
    && config.url != '/api/Course/Times' && config.url != '/api/SignUp/Invoice'
    && config.url != '/api/Course/Chapter'  && config.url !=  '/api/SignUp/GetPayUrl' &&  config.url !=  '/api/SignUp/OrderQuery') {
        loadingInstance = Loading.service({ fullscreen: true ,background:'rgba(0, 0, 0, 0.6)'});
    }
    
    return config;
    }, function (err) {
    return Promise.reject(err);
});
axios.interceptors.response.use(function (response) {
    //   window.scrollTo(0,0)
    if (loadingInstance) {
        loadingInstance.close()
    }
    if(response.data.code !== 200){ 
        if(response.data.code === 401) {
            MessageBox.alert('<div class="bgIconAlert">'+response.data.msg+'</div>', '', {
                dangerouslyUseHTMLString: true,
                // confirmButtonText: '关闭',
                center: true
            }).then(()=>{
                router.push({name: 'login'})
            }).catch(() => {
                router.push({name: 'login'})
            })
        } else {
            Message.error({
                message: response.data.msg,
            });
        }
    }
    return response;
}, function (error) {
    if (loadingInstance) {
        loadingInstance.close()
    }
    if (error.config ) {
       
            if (error.response.status) {
                let statusC =  error.response.status
                if (statusC == 500 || statusC == 501 || statusC == 502 || statusC == 503  || statusC == 504 || statusC == 401) {
                    Message.error({
                        message:'错误提示'+statusC,
                    });
                } 
            }
    
    }
    return Promise.reject(error.config);

});
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js